"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_onclickoutside_1 = require("react-onclickoutside");
var Dropdown_st_css_1 = require("./Dropdown.st.css");
var popover_1 = require("../popover");
var dropdown_content_1 = require("../dropdown-content");
var constants_1 = require("./constants");
/**
 * Dropdown
 */
var DropdownComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownComponent, _super);
    function DropdownComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdownContentRef = null;
        _this.state = { isOpen: false, selectedIds: [] };
        _this.close = _this.close.bind(_this);
        _this.onPopoverClick = _this.onPopoverClick.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onOptionHover = _this.onOptionHover.bind(_this);
        _this.onOptionClick = _this.onOptionClick.bind(_this);
        _this._onContentMouseDown = _this._onContentMouseDown.bind(_this);
        return _this;
    }
    DropdownComponent.prototype.componentDidMount = function () {
        this.initializeSelectedOptions();
    };
    DropdownComponent.prototype.componentDidUpdate = function (prevProps) {
        if (!DropdownComponent.areSelectedIdsEqual(this.props.initialSelectedIds, prevProps.initialSelectedIds)) {
            this.initializeSelectedOptions();
        }
    };
    DropdownComponent.prototype.initializeSelectedOptions = function () {
        var _a = this.props, initialSelectedIds = _a.initialSelectedIds, options = _a.options, onInitialSelectedOptionsSet = _a.onInitialSelectedOptionsSet;
        var selectedOptions = (initialSelectedIds || [])
            .map(function (id) { return options.find(function (option) { return id === option.id; }); })
            .filter(function (option) { return option && !option.isDisabled && option.isSelectable; });
        var selectedIds = selectedOptions.map(function (x) { return x && x.id; });
        this.setState({
            selectedIds: selectedIds,
        });
        onInitialSelectedOptionsSet && onInitialSelectedOptionsSet(selectedOptions);
    };
    DropdownComponent.prototype.handleClickOutside = function () {
        this.close();
    };
    DropdownComponent.prototype._onExpandedChange = function () {
        if (this.props.onExpandedChange) {
            this.props.onExpandedChange(this.state.isOpen);
        }
    };
    DropdownComponent.prototype.open = function (onOpen) {
        var _this = this;
        if (onOpen === void 0) { onOpen = function () { return null; }; }
        if (this.state.isOpen) {
            onOpen && onOpen();
        }
        else {
            this.setState({ isOpen: true }, function () {
                _this._onExpandedChange();
                onOpen();
            });
        }
    };
    DropdownComponent.prototype.onPopoverClick = function () {
        if (this.state.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    };
    DropdownComponent.prototype.close = function () {
        if (this.state.isOpen) {
            this.setState({ isOpen: false }, this._onExpandedChange);
        }
    };
    DropdownComponent.prototype.getSelectedOption = function () {
        return this.dropdownContentRef
            ? this.dropdownContentRef.getSelectedOption()
            : null;
    };
    DropdownComponent.prototype.onKeyboardSelect = function () {
        var selectedOption = this.getSelectedOption();
        this.onOptionClick(selectedOption);
    };
    DropdownComponent.prototype.isClosingKey = function (key) {
        return key === 'Tab' || key === 'Enter' || key === 'Escape';
    };
    DropdownComponent.prototype.onKeyDown = function (evt) {
        var _this = this;
        var eventKey = evt.key;
        if (!this.state.isOpen && this.isClosingKey(eventKey)) {
            return;
        }
        this.open(function () {
            _this.dropdownContentRef &&
                _this.dropdownContentRef.onKeyDown(eventKey, evt);
            switch (eventKey) {
                case 'Enter': {
                    _this.onKeyboardSelect();
                    var multi = _this.props.multi;
                    !multi && _this.close();
                    if (_this.getSelectedOption() !== null) {
                        evt.preventDefault();
                    }
                    break;
                }
                case 'Tab': {
                    _this.onKeyboardSelect();
                    _this.close();
                    break;
                }
                case 'Escape': {
                    _this.close();
                    break;
                }
                default:
            }
        });
    };
    DropdownComponent.prototype._onContentMouseDown = function (e) {
        var onContentMouseDown = this.props.onContentMouseDown;
        onContentMouseDown && onContentMouseDown(e);
    };
    DropdownComponent.prototype.onOptionHover = function (option) {
        if (this.props.onOptionHover) {
            this.props.onOptionHover(option);
        }
    };
    DropdownComponent.prototype.onOptionClick = function (option) {
        var _a = this.props, onSelect = _a.onSelect, onDeselect = _a.onDeselect, multi = _a.multi, allowReselect = _a.allowReselect;
        var selectedIds = this.state.selectedIds;
        var newState = {
            isOpen: !!multi,
            selectedIds: selectedIds,
        };
        var callback = onSelect;
        if (multi) {
            // Multi select
            if (option) {
                // if option was clicked (could be null when Autocomplete receives a new string)
                if (selectedIds.includes(option.id)) {
                    // if clicked a selected option, unselect it
                    newState.selectedIds = selectedIds.filter(function (x) { return x !== option.id; });
                    callback = onDeselect;
                }
                else {
                    // if clicked a new option, add it to selection
                    newState.selectedIds = tslib_1.__spreadArrays(selectedIds, [option.id]);
                }
            }
            // Single select
        }
        else if (option) {
            // if option was clicked (could be null when Autocomplete receives a new string)
            if (selectedIds.includes(option.id)) {
                this.close();
                if (!allowReselect) {
                    // if clicked on the selected item, exit and do nothing
                    return;
                }
            }
            else {
                // if clicked on a new option, make it the selected
                newState.selectedIds = [option.id];
            }
        }
        else {
            // if non existing option selected, unselect existing ones
            newState.selectedIds = [];
        }
        this.setState(newState, function () { return callback(option); });
    };
    DropdownComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, openTrigger = _a.openTrigger, placement = _a.placement, options = _a.options, children = _a.children, showArrow = _a.showArrow, fixedFooter = _a.fixedFooter, fixedHeader = _a.fixedHeader, disabled = _a.disabled, timeout = _a.timeout, forceContentElementVisibility = _a.forceContentElementVisibility, inlineStyles = _a.style, id = _a.id, flip = _a.flip, fixed = _a.fixed, moveBy = _a.moveBy, role = _a.role, contentId = _a.contentId, optionsContainerZIndex = _a.optionsContainerZIndex;
        var _b = this.state, isOpen = _b.isOpen, selectedIds = _b.selectedIds;
        var hasContent = Boolean((options && options.length) || fixedHeader || fixedFooter);
        var shown = forceContentElementVisibility || (isOpen && !disabled && hasContent);
        return (React.createElement(popover_1.Popover, tslib_1.__assign({}, Dropdown_st_css_1.default('root', { 'content-visible': shown }, this.props), { placement: placement, shown: shown, showArrow: showArrow, timeout: timeout, onClick: !disabled && openTrigger === constants_1.CLICK
                ? function () { return _this.onPopoverClick(); }
                : undefined, onMouseEnter: !disabled && openTrigger === constants_1.HOVER ? function () { return _this.open(); } : undefined, onKeyDown: !disabled ? this.onKeyDown : undefined, onMouseLeave: !disabled && openTrigger === constants_1.HOVER ? this.close : undefined, style: inlineStyles, id: id, flip: flip, fixed: fixed, moveBy: moveBy, role: role, zIndex: optionsContainerZIndex }),
            React.createElement(popover_1.Popover.Element, null, children),
            React.createElement(popover_1.Popover.Content, null,
                React.createElement(dropdown_content_1.DropdownContent, { className: Dropdown_st_css_1.default.dropdownContent, "data-hook": "dropdown-content", ref: function (dropdownContent) { return (_this.dropdownContentRef = dropdownContent); }, options: options, fixedFooter: fixedFooter, fixedHeader: fixedHeader, selectedIds: selectedIds, onOptionClick: this.onOptionClick, onOptionHover: this.onOptionHover, onMouseDown: this._onContentMouseDown, optionsContainerId: contentId }))));
    };
    DropdownComponent.displayName = 'Dropdown';
    DropdownComponent.areSelectedIdsEqual = function (selectedIds1, selectedIds2) {
        if ((selectedIds1 === undefined && selectedIds2 === undefined) ||
            (selectedIds1 === null && selectedIds2 === null)) {
            return true;
        }
        return (Array.isArray(selectedIds1) &&
            Array.isArray(selectedIds2) &&
            selectedIds1.length === selectedIds2.length &&
            selectedIds1.every(function (item, index) { return item === selectedIds2[index]; }));
    };
    return DropdownComponent;
}(React.PureComponent));
exports.DropdownComponent = DropdownComponent;
exports.Dropdown = react_onclickoutside_1.default(DropdownComponent);
//# sourceMappingURL=Dropdown.js.map